var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.success)?_c('div',{class:_vm.withoutAnimation ? '' : 'uk-animation-fade'},[_c('InfoBox',{class:_vm.withClasses,attrs:{"closeable":_vm.closeable,"mode":"success"}},[_vm._v(" "+_vm._s(_vm.message)+" "),_vm._t("default")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }